import { messages, intl } from '../messages';
import { actions as emrSchedullingFrequencyActions } from 'src/redux/data/emrSchedullingFrequency';

export const emrSchedullingFrequencyErrorNotificationMessagesMap = {
  [emrSchedullingFrequencyActions.createEmrSchedullingFrequncyByOperatorId
    .type]: (_, err) => ({
    message: intl.formatMessage(messages.createEmrSchedullingFrequncyError),
    description: err || '',
  }),
};

export const emrSchedullingFrequencySuccessNotificationMessagesMap = {
  [emrSchedullingFrequencyActions.createEmrSchedullingFrequncyByOperatorId
    .type]: () => ({
    message: intl.formatMessage(messages.createEmrSchedullingFrequncySuccess),
  }),
};
